import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/login',
        name: 'LoginView',
        component: () => import('../views/LoginView.vue')
    },
    {
        path: '/',
        name: 'MainView',
        component: () => import('../views/MainView.vue'),
        redirect: '/device-type',
        children: [
            {
                path: '/device-type',
                name: 'DeviceType',
                component: () => import('../views/DeviceTypeView.vue')
            },
            {
                path: '/ota-file',
                name: 'OtaFile',
                component: () => import('../views/OtaFileView.vue')
            },
            {
                path: '/add-device-type',
                name: 'AddDeviceType',
                component: () => import('../views/OptDeviceTypeView.vue')
            },
            {
                path: '/edit-device-type/:cid',
                name: 'EditDeviceType',
                component: () => import('../views/OptDeviceTypeView.vue')
            },
            {
                path: '/upload-ota-file',
                name: 'UploadOtaFile',
                component: () => import('../views/UploadOTAFileView.vue')
            },
            {
                path: '/edit-ote-file/:rid',
                name: 'EditOtaFile',
                component: () => import('../views/UploadOTAFileView.vue')
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router